import type {Result, UseCase} from 'framework';
import type {AuthRepository, ResetPasswordData} from '../ports/auth.repository';
import type {ResetPasswordError} from '../../domain/errors';

export class ResetPassword implements UseCase<[ResetPasswordData], undefined> {
  constructor(private readonly authRepository: AuthRepository) {}

  execute(data: ResetPasswordData): Promise<Result<undefined, ResetPasswordError>> {
    return this.authRepository.resetPassword(data);
  }
}
